import {
  Action,
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { IAssessment } from "../main.interfaces";
import API from "../api";
import { IOrganization } from "@/interfaces/organization.interface";

@Module({
  dynamic: true,
  namespaced: true,
  name: "assessments",
  store
})
class AssessmentsModule extends VuexModule {
  allAssessments: IAssessment[] = [];
  allDepartments: string[] = [];

  @Mutation
  async reset() {
    this.allAssessments = [];
  }

  @MutationAction
  async refreshAssessments() {
    const allAssessments = await API.getAllAssessments();
    return {
      allAssessments: allAssessments
    };
  }

  @Mutation
  async getSpecificUserAssessments(username: string) {
    this.allAssessments = await API.getSpecificUserAssessments(username);
  }

  @Mutation
  async refreshDepartments() {
    const allDepartments = await API.getAllDepartments();
    return allDepartments;
  }

  @Action
  async getAvailableAssessments() {
    if (this.allAssessments.length === 0) {
      await this.refreshAssessments();
    }
    return this.allAssessments;
  }

  @Action
  async deleteAssessment(id: string) {
    const deletionResult = await API.deleteAssessment(id);
    this.refreshAssessments();
    return deletionResult;
  }

  @Action
  async createOrUpdateAssessment(assessment: IAssessment) {
    const createdAssessment = await API.createOrUpdateAssessment(assessment);
    this.refreshAssessments();
    this.refreshDepartments();
    return createdAssessment;
  }
}

export default getModule(AssessmentsModule);
